import { render } from "./SchoolLogin.vue?vue&type=template&id=b686f93e"
import script from "./SchoolLogin.vue?vue&type=script&lang=js"
export * from "./SchoolLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__